import React, {Component} from 'react';
import {Route, Redirect, Switch} from 'react-router-dom';
import {getToken} from './local-storage';

export const ReactRoute = (route) => {
    route.routes.map((routeItem) => {
        routeItem.path = route.path + routeItem.path;
        routeItem.auth = route.auth || routeItem.auth;
        routeItem = ReactRoute(routeItem);
        return routeItem;
    });
    return route;
};

export const RouteWithSubRoutes = (route) => (
    <Route path={route.path} render={(props) => {
        const component = <route.component {...props} routes={route.routes}/>;
        if (route.auth) {
            if (getToken()) {
                return component;
            } else {
                return (<Redirect to={{
                    pathname: '/login',
                    state: {
                        from: props.location
                    }
                }}/>);
            }
        } else {
            return component;
        }
    }}/>
);

export class DefaultRouteHandler extends Component {
    render() {
        return (
            <Switch>
                {this.props.routes.map((route, i) => (<RouteWithSubRoutes key={i} {...route}/>))}
            </Switch>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/utils/router-utils.jsx